import { render } from "./RoomContent.vue?vue&type=template&id=70e1c1b4&scoped=true"
import script from "./RoomContent.vue?vue&type=script&lang=js"
export * from "./RoomContent.vue?vue&type=script&lang=js"

import "./RoomContent.vue?vue&type=style&index=0&id=70e1c1b4&lang=scss&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e1c1b4"]])

export default __exports__